// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Mobile navigation system: slide-in drawer + bottom tab bar.
   Loaded AFTER index.css so these rules win at equal specificity.
   Breakpoints: mobile <=576, tablet 577-991, laptop 992-1280, desktop >=1281.
   ========================================================================== */

/* --- Hamburger button (Header) ------------------------------------------- */
/* Desktop default: hidden. The left rail is the navigation. */
.hamburger-btn {
  display: none;
}
/* --- Drawer overlay ------------------------------------------------------ */
/* Hidden / non-interactive by default (desktop). */
.drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 199;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

/* --- Bottom tab bar ------------------------------------------------------ */
/* Hidden on tablet/laptop/desktop; revealed only at <=576px below. */
.bottom-nav {
  display: none;
}

/* ==========================================================================
   Tablet + large phones (<=991px): turn the left rail into an off-canvas
   slide-in drawer. The rail is hidden off-screen until opened.
   ========================================================================== */
@media (max-width: 991px) {
  .hamburger-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    min-width: 44px;
    border: none;
    background: transparent;
    color: var(--text-primary);
    border-radius: 8px;
    cursor: pointer;
  }

  .hamburger-btn:hover {
    background: var(--bg-tertiary);
  }

  /* Off-canvas drawer: full sidebar width, slid out of view. Override the
     icons-only collapsed behaviour from index.css so the drawer shows labels. */
  .sidebar {
    width: var(--sidebar-width);
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 200;
    box-shadow: 2px 0 16px rgba(0, 0, 0, 0.25);
  }

  /* Force labels/logo back on inside the drawer (index.css hides them <=992px). */
  .sidebar .logo-text,
  .sidebar .nav-item span,
  .sidebar .version-info,
  .sidebar-footer {
    display: revert;
  }

  .sidebar .logo,
  .sidebar .nav-item {
    justify-content: flex-start;
  }

  .sidebar .nav-item {
    padding: 12px 16px;
    min-height: 44px;
  }

  /* Open state. */
  .sidebar.drawer-open {
    transform: translateX(0);
  }

  .drawer-overlay.open {
    opacity: 1;
    visibility: visible;
  }

  /* index.css bumps .drawer-overlay to z-index:1000 when the test-mode ribbon
     is present; keep the drawer panel above its own overlay in that case. */
  .dashboard-layout:has(.test-mode-ribbon) .sidebar {
    z-index: 1001;
    box-shadow: none;
  }
  .dashboard-layout:has(.test-mode-ribbon) .drawer-overlay {
    z-index: 1000;
  }

  /* Content takes the full width; no left rail reserved. */
  .main-content {
    margin-left: 0;
  }

  .dashboard-layout.sidebar-collapsed .main-content {
    margin-left: 0;
  }
}

/* ==========================================================================
   Mobile (<=576px): override index.css \`.sidebar { display: none }\` so the
   drawer still works, and reveal the fixed bottom tab bar.
   ========================================================================== */
@media (max-width: 576px) {
  /* index.css hides the sidebar entirely here — restore it as a drawer. */
  .sidebar {
    display: flex;
  }

  .main-content {
    margin-left: 0;
  }

  /* Bottom tab bar. */
  .bottom-nav {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 150;
    background: var(--bg-primary);
    border-top: 1px solid var(--border-color);
    padding-bottom: env(safe-area-inset-bottom);
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  }

  .bottom-nav-item {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    min-height: 56px;
    padding: 6px 2px;
    border: none;
    background: transparent;
    color: var(--text-secondary);
    font-size: 11px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.15s ease;
  }

  .bottom-nav-item span {
    line-height: 1.1;
    white-space: nowrap;
  }

  .bottom-nav-item.active {
    color: var(--accent-primary);
  }

  /* --- Center elevated "Create Invoice" action ------------------------- */
  .bottom-nav-fab {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 3px;
    min-height: 56px;
    padding: 6px 2px;
    text-decoration: none;
    cursor: pointer;
    color: var(--accent-primary);
  }

  .bottom-nav-fab-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    margin-top: -26px; /* lift the button above the bar's top edge */
    border-radius: 50%;
    background: var(--accent-primary);
    color: #fff;
    border: 3px solid var(--bg-primary);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    transition: transform 0.15s ease;
  }

  .bottom-nav-fab:active .bottom-nav-fab-circle {
    transform: scale(0.92);
  }

  .bottom-nav-fab-label {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.1;
    white-space: nowrap;
  }

  /* Keep page content clear of the fixed bottom bar (+ raised FAB).
     overflow-x guard: no page may scroll horizontally on mobile. */
  .page-content {
    padding-bottom: calc(88px + env(safe-area-inset-bottom));
    overflow-x: hidden;
  }

  @media (prefers-reduced-motion: reduce) {
    .bottom-nav-item,
    .bottom-nav-fab-circle {
      transition: none;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/nav.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E,8EAA8E;AAC9E,8DAA8D;AAC9D;EACE,aAAa;AACf;AACA,8EAA8E;AAC9E,mDAAmD;AACnD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,8EAA8E;AAC9E,qEAAqE;AACrE;EACE,aAAa;AACf;;AAEA;;;+EAG+E;AAC/E;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;gFAC8E;EAC9E;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;IACZ,0CAA0C;EAC5C;;EAEA,gFAAgF;EAChF;;;;IAIE,eAAe;EACjB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;4EAC0E;EAC1E;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA,yDAAyD;EACzD;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;;+EAG+E;AAC/E;EACE,wEAAwE;EACxE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,yCAAyC;IACzC,2CAA2C;IAC3C,2CAA2C;EAC7C;;EAEA;IACE,SAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,0EAA0E;EAC1E;IACE,SAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,6CAA6C;IAChE,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,mCAAmC;IACnC,0CAA0C;IAC1C,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;mEACiE;EACjE;IACE,wDAAwD;IACxD,kBAAkB;EACpB;;EAEA;IACE;;MAEE,gBAAgB;IAClB;EACF;AACF","sourcesContent":["/* ==========================================================================\n   Mobile navigation system: slide-in drawer + bottom tab bar.\n   Loaded AFTER index.css so these rules win at equal specificity.\n   Breakpoints: mobile <=576, tablet 577-991, laptop 992-1280, desktop >=1281.\n   ========================================================================== */\n\n/* --- Hamburger button (Header) ------------------------------------------- */\n/* Desktop default: hidden. The left rail is the navigation. */\n.hamburger-btn {\n  display: none;\n}\n/* --- Drawer overlay ------------------------------------------------------ */\n/* Hidden / non-interactive by default (desktop). */\n.drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 199;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n/* --- Bottom tab bar ------------------------------------------------------ */\n/* Hidden on tablet/laptop/desktop; revealed only at <=576px below. */\n.bottom-nav {\n  display: none;\n}\n\n/* ==========================================================================\n   Tablet + large phones (<=991px): turn the left rail into an off-canvas\n   slide-in drawer. The rail is hidden off-screen until opened.\n   ========================================================================== */\n@media (max-width: 991px) {\n  .hamburger-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n    border: none;\n    background: transparent;\n    color: var(--text-primary);\n    border-radius: 8px;\n    cursor: pointer;\n  }\n\n  .hamburger-btn:hover {\n    background: var(--bg-tertiary);\n  }\n\n  /* Off-canvas drawer: full sidebar width, slid out of view. Override the\n     icons-only collapsed behaviour from index.css so the drawer shows labels. */\n  .sidebar {\n    width: var(--sidebar-width);\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    z-index: 200;\n    box-shadow: 2px 0 16px rgba(0, 0, 0, 0.25);\n  }\n\n  /* Force labels/logo back on inside the drawer (index.css hides them <=992px). */\n  .sidebar .logo-text,\n  .sidebar .nav-item span,\n  .sidebar .version-info,\n  .sidebar-footer {\n    display: revert;\n  }\n\n  .sidebar .logo,\n  .sidebar .nav-item {\n    justify-content: flex-start;\n  }\n\n  .sidebar .nav-item {\n    padding: 12px 16px;\n    min-height: 44px;\n  }\n\n  /* Open state. */\n  .sidebar.drawer-open {\n    transform: translateX(0);\n  }\n\n  .drawer-overlay.open {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  /* index.css bumps .drawer-overlay to z-index:1000 when the test-mode ribbon\n     is present; keep the drawer panel above its own overlay in that case. */\n  .dashboard-layout:has(.test-mode-ribbon) .sidebar {\n    z-index: 1001;\n    box-shadow: none;\n  }\n  .dashboard-layout:has(.test-mode-ribbon) .drawer-overlay {\n    z-index: 1000;\n  }\n\n  /* Content takes the full width; no left rail reserved. */\n  .main-content {\n    margin-left: 0;\n  }\n\n  .dashboard-layout.sidebar-collapsed .main-content {\n    margin-left: 0;\n  }\n}\n\n/* ==========================================================================\n   Mobile (<=576px): override index.css `.sidebar { display: none }` so the\n   drawer still works, and reveal the fixed bottom tab bar.\n   ========================================================================== */\n@media (max-width: 576px) {\n  /* index.css hides the sidebar entirely here — restore it as a drawer. */\n  .sidebar {\n    display: flex;\n  }\n\n  .main-content {\n    margin-left: 0;\n  }\n\n  /* Bottom tab bar. */\n  .bottom-nav {\n    display: flex;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 150;\n    background: var(--bg-primary);\n    border-top: 1px solid var(--border-color);\n    padding-bottom: env(safe-area-inset-bottom);\n    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);\n  }\n\n  .bottom-nav-item {\n    flex: 1 1 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n    min-height: 56px;\n    padding: 6px 2px;\n    border: none;\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 11px;\n    font-weight: 500;\n    text-decoration: none;\n    cursor: pointer;\n    transition: color 0.15s ease;\n  }\n\n  .bottom-nav-item span {\n    line-height: 1.1;\n    white-space: nowrap;\n  }\n\n  .bottom-nav-item.active {\n    color: var(--accent-primary);\n  }\n\n  /* --- Center elevated \"Create Invoice\" action ------------------------- */\n  .bottom-nav-fab {\n    flex: 1 1 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 3px;\n    min-height: 56px;\n    padding: 6px 2px;\n    text-decoration: none;\n    cursor: pointer;\n    color: var(--accent-primary);\n  }\n\n  .bottom-nav-fab-circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 52px;\n    height: 52px;\n    margin-top: -26px; /* lift the button above the bar's top edge */\n    border-radius: 50%;\n    background: var(--accent-primary);\n    color: #fff;\n    border: 3px solid var(--bg-primary);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n    transition: transform 0.15s ease;\n  }\n\n  .bottom-nav-fab:active .bottom-nav-fab-circle {\n    transform: scale(0.92);\n  }\n\n  .bottom-nav-fab-label {\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.1;\n    white-space: nowrap;\n  }\n\n  /* Keep page content clear of the fixed bottom bar (+ raised FAB).\n     overflow-x guard: no page may scroll horizontally on mobile. */\n  .page-content {\n    padding-bottom: calc(88px + env(safe-area-inset-bottom));\n    overflow-x: hidden;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .bottom-nav-item,\n    .bottom-nav-fab-circle {\n      transition: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
